module.exports = __webpack_public_path__ + "static/media/sedan-white-inactive.f4022a73.png";